export const myPubDetailBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications"
        },
        {
            label: `Detalle - ${text}`,
        }
    ];
}

export const myPubEditBreadCrumb = (id: any, text: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications"
        },
        {
            label: "Detalle",
            to: "/profile/my_publications/" + id + "/detail"
        },
        {
            label: `Revisar - ${text}`
        }
    ];
}

export const myPubManagementBreadCrumb = (id: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications"
        },
        {
            label: `Gestión`,
            to: `/profile/my_publications/${id}/management`,
            bold: true
        }
    ];
}

export const myPubReviewBreadCrumb = (id: any, text: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications"
        },
        {
            label: "Detalle",
            to: "/profile/my_publications/" + id + "/detail"
        },
        {
            label: `Revisar - ${text}`
        }
    ];
}

export const myPubQRBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications"
        },
        
        {
            label: `Generar QR - ${text}`
        }
    ];
}

export const myPubInspectionsBreadCrumb = (id: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications"
        },
        {
            label: "Ver inspecciones",
            to: "/profile/my_publications/" + id + "/inspections"
        }
    ];
}

export const myBuysDetailBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis compras",
            to: "/profile/my_buys"
        },
        {
            label: `Detalle - ${text}`
        }
    ];
}

export const myBuysPaymentsBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis compras",
            to: "/profile/my_buys"
        },
        {
            label: `Pagos - ${text}`
        }
    ];
}

export const myBuysPaymentMethodBreadCrumb = (id: any, text: any) => {

    return [
        {
            label: "Mis compras",
            to: "/profile/my_buys"
        },
        {
            label: "Pagos",
            to: "/profile/my_buys/" + id + "/payments"
        },
        {
            label: `Vale vista - ${text}`
        }
    ];
}

export const myBuysQRBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis compras",
            to: "/profile/my_buys"
        },
        {
            label: `Generar QR - ${text}`
        }
    ];
}

export const myBuysInspectionsBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis compras",
            to: "/profile/my_buys"
        },
        {
            label: `Ver inspecciones - ${text}`
        }
    ];
}


export const myPubBrandDetailBreadCrumb = (text: any) => {
    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications_brand"
        },
        {
            label: `Detalle - ${text}`,
        }
    ];
}

export const myPubBrandEditBreadCrumb = (id: any, text: any) => {
    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications_brand"
        },
        {
            label: "Detalle",
            to: "/profile/my_publications_brand/" + id + "/detail"
        },
        {
            label: `Revisar - ${text}`
        }
    ];
}

export const myPubBrandManagementBreadCrumb = (id: any) => {
    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications_brand"
        },
        {
            label: `Gestión`,
            to: `/profile/my_publications_brand/${id}/management`,
            bold: true
        }
    ];
}

export const myPubBrandReviewBreadCrumb = (id: any, text: any) => {
    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications_brand"
        },
        {
            label: "Detalle",
            to: "/profile/my_publications_brand/" + id + "/detail"
        },
        {
            label: `Revisar - ${text}`
        }
    ];
}

export const myPubBrandQRBreadCrumb = (text: any) => {
    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications_brand"
        },
        {
            label: `Generar QR - ${text}`
        }
    ];
}

export const myPubBrandInspectionsBreadCrumb = (id: any) => {
    return [
        {
            label: "Mis publicaciones",
            to: "/profile/my_publications_brand"
        },
        {
            label: "Ver inspecciones",
            to: "/profile/my_publications_brand/" + id + "/inspections"
        }
    ];
}